import(/* webpackMode: "eager" */ "/vercel/path0/app/(public)/cookies/page.tsx");
